import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgAccessible = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 17,
  height: 19,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.1v1.026A4.002 4.002 0 0 0 5 18a4.002 4.002 0 0 0 3.874-2.998H9.9A5.002 5.002 0 0 1 0 14a5.002 5.002 0 0 1 4-4.9Zm2.55-2.348.1.076L9.186 9H12v1H8.815L6 7.588V12.5a.5.5 0 0 0 .41.492L6.5 13h4.207l3.793 3.793 1-1 .707.707-1.707 1.707L10.293 14H6.5a1.5 1.5 0 0 1-1.493-1.355L5 12.5V7.587a1 1 0 0 1 1.55-.835ZM6.5.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgAccessible;